import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaFlask, FaInfoCircle } from 'react-icons/fa';

const trlLevels = [
  {
    level: '1',
    title: 'سطح ۱ - بررسی یافته‌ها و اصول علمی',
    shortDesc: 'مطالعه اولیه و شناسایی اصول علمی',
    description: 'ادبیات موضوع تحقیق به صورت کامل مورد بررسی قرار گرفته است. قوانین و نظریه‌های علمی (مثلا فیزیکی یا شیمیایی) مورد نیاز جهت ساخت فناوری محصول یا بهبود فرایند پیشنهادی شناسایی و مشخص شده‌اند.',
    color: 'from-red-500 to-red-600'
  },
  {
    level: '2',
    title: 'سطح ۲ - فرمول‌بندی مفهوم',
    shortDesc: 'تحقیقات کاربردی و فرمول‌بندی کاربرد فناوری',
    description: 'تجزیه و تحلیل عمقی مطالعات اولیه انجام شده در مرحله قبل با هدف اطمینان از امکان عملیاتی شدن ایده تحقیق انجام شده است.',
    color: 'from-orange-500 to-orange-600'
  },
  {
    level: '3',
    title: 'سطح ۳ - اثبات تحلیلی و تجربی',
    shortDesc: 'تست امکان‌سنجی اجزاء در آزمایشگاه',
    description: 'تست‌های امکان‌سنجی اجزاء فناوری، محصول یا فرایند به صورت مجزا در محیط آزمایشگاهی برای اطمینان از عملیاتی شدن ایده تحقیق انجام شد.',
    color: 'from-amber-500 to-amber-600'
  },
  {
    level: '4',
    title: 'سطح ۴ - اعتبارسنجی اجزای اصلی در آزمایشگاه',
    shortDesc: 'ساخت نمونه اولیه و تست در محیط آزمایشگاهی',
    description: 'نمونه اولیه از طریق ادغام و یکپارچه‌سازی اجزاء اصلی فناوری ساخته شده است. تست آزمایشگاهی نمونه اولیه موفقیت‌آمیز بوده است.',
    color: 'from-yellow-500 to-yellow-600'
  },
  {
    level: '5',
    title: 'سطح ۵ - اعتبارسنجی اجزای نیمه یکپارچه',
    shortDesc: 'تست در محیط شبیه‌سازی شده',
    description: 'ساخت نمونه اولیه با دقت بیشتر از طریق ادغام و یکپارچه‌سازی اجزاء اصلی. تست آزمایشگاهی نمونه اولیه در محیط شبیه‌سازی شده.',
    color: 'from-lime-500 to-lime-600'
  },
  {
    level: '6',
    title: 'سطح ۶ - نمایش نمونه در مقیاس پایلوت',
    shortDesc: 'تست در شرایط شبیه‌سازی شده',
    description: 'مدل یا نمونه با پیکربندی نزدیک به مدل مورد انتظار ساخته شده است. مدل در شرایط شبیه‌سازی شده نمایش داده شده و مورد آزمایش قرار گرفته است.',
    color: 'from-green-500 to-green-600'
  },
  {
    level: '7',
    title: 'سطح ۷ - تست نمونه نهایی در محیط واقعی',
    shortDesc: 'آزمایش نمونه نهایی تحت شرایط محدود در محیط واقعی',
    description: 'مدل یا نمونه نهایی فناوری ایجاد گردیده است. مدل نهایی در محیط واقعی تحت شرایط محدود مورد آزمایش واقع شد.',
    color: 'from-teal-500 to-teal-600'
  },
  {
    level: '8',
    title: 'سطح ۸ - تکمیل خروجی نهایی پروژه',
    shortDesc: 'ارزیابی و رفع مشکلات نهایی در محیط واقعی',
    description: 'نمونه نهایی با پیکربندی نهایی ایجاد شده و با موفقیت در محیط عملیاتی آزمایش شده است. محصول برای برآورده نمودن عملکردهای مورد انتظار ارزیابی گردیده است.',
    color: 'from-blue-500 to-blue-600'
  },
  {
    level: '9',
    title: 'سطح ۹ - اثبات عملکرد موفق',
    shortDesc: 'عملکرد موفق در شرایط واقعی',
    description: 'خروجی نهایی پروژه تحقیقاتی به صورت کامل ساخته شده و در طیف متنوعی از شرایط عملیاتی به‌کار گرفته شده و عملکرد موفقت‌آمیز آن به اثبات رسیده است.',
    color: 'from-indigo-500 to-indigo-600'
  }
];

function TRLInfo() {
  const [selectedTRL, setSelectedTRL] = useState(null);

  return (
    <div className="bg-white rounded-3xl p-6 md:p-10 shadow-2xl border-2 border-primary-200">
      <div className="text-center mb-8 md:mb-12">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-gradient-blue flex items-center justify-center gap-3 flex-wrap">
          <FaFlask className="text-primary-600" />
          سطوح آمادگی فناوری (TRL)
        </h2>
        <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
          Technology Readiness Level - معیاری برای ارزیابی میزان آمادگی و پختگی یک فناوری
        </p>
      </div>

      <div className="grid gap-4 md:gap-6">
        {trlLevels.map((trl, index) => (
          <motion.div
            key={trl.level}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: index * 0.1 }}
            viewport={{ once: true }}
            className="group"
          >
            <div 
              className={`bg-gradient-to-br from-gray-50 to-white rounded-2xl p-4 md:p-6 border-2 transition-all cursor-pointer ${
                selectedTRL === trl.level 
                  ? 'border-primary-500 shadow-xl' 
                  : 'border-gray-200 hover:border-primary-300 shadow-md hover:shadow-lg'
              }`}
              onClick={() => setSelectedTRL(selectedTRL === trl.level ? null : trl.level)}
            >
              <div className="flex items-start gap-4">
                <div className={`flex-shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-xl bg-gradient-to-br ${trl.color} flex items-center justify-center text-white font-bold text-xl md:text-2xl shadow-lg`}>
                  {trl.level}
                </div>
                
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2 leading-tight">
                    {trl.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-600 mb-3">
                    {trl.shortDesc}
                  </p>
                  
                  <motion.div
                    initial={false}
                    animate={{ height: selectedTRL === trl.level ? 'auto' : 0 }}
                    className="overflow-hidden"
                  >
                    <div className="pt-3 border-t-2 border-gray-200">
                      <p className="text-sm md:text-base text-gray-700 leading-relaxed text-justify">
                        {trl.description}
                      </p>
                    </div>
                  </motion.div>
                  
                  <button 
                    className="mt-3 text-primary-600 hover:text-primary-700 font-semibold text-sm flex items-center gap-2"
                  >
                    <FaInfoCircle />
                    {selectedTRL === trl.level ? 'بستن جزئیات' : 'مشاهده جزئیات'}
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default TRLInfo;
export { trlLevels };
